import { ca } from '@cian/analytics';
import { TDevice } from '@cian/utils';

import { EFrequency, TOnSubmitSaveSearchParams } from 'shared/common/packages/SaveSearchModal';

import { getSiteType } from '../../utils/analytics';

export const trackSaveSearchModalOpen = () => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'open',
    category: 'subscription',
    label: 'saved_search',
    page: {
      pageType: 'Listing',
      listingType: 'map',
    },
  });
};

export const trackSaveSearchModalClose = () => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'close',
    category: 'saved_search',
    label: 'window',
  });
};

type TTrackSuburbanSaveSearchSubscribed = TOnSubmitSaveSearchParams & {
  deviceType: TDevice;
  queryString: string;
};

const notificationFrequencyMap: Record<EFrequency, string> = {
  [EFrequency.Asap]: 'Asap',
  [EFrequency.Hourly]: 'Hourly',
  [EFrequency.Daily]: 'Daily',
  [EFrequency.Weekly]: 'Weekly',
};

export const trackSaveSearchSubscribed = ({
  frequency,
  deviceType,
  queryString,
}: TTrackSuburbanSaveSearchSubscribed) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'subscription',
    action: 'send',
    label: 'saved_search',
    page: {
      pageType: 'Listing',
      listingType: 'map',
      siteType: getSiteType(deviceType),
      queryString,
      extra: {
        period: notificationFrequencyMap[frequency],
      },
    },
  });
};
